import React, { useEffect, useState } from 'react';
// import {Card,CardHeader,CardContent} from '@material-ui/core';
import MemberCard from '../../../components/memberCard/card';
import translates from '../../../translation.json';
import { lang } from '../../../config/app.config';
import { useParams } from 'react-router';
import { fetchStaffs } from '../../../services/staff.service';
import staff from '../../../models/staff.model';
import Preloader from '../../../components/PreLoader';

interface params{
  dist_slug:string
}
const HomeMembers:React.FC = () =>{

  const {dist_slug} = useParams<params>();

  const [loading,setLoading] = useState<boolean>(false);
  const [members,setEc] = useState<Array<staff>|undefined>(undefined);

  const fetchMember= async()=>{
    setLoading(true);
    const staffs =await fetchStaffs(dist_slug?dist_slug:'head-office','member');
    setEc(staffs)
    setLoading(false);
  }

  useEffect(()=>{
    fetchMember();
  },[])// eslint-disable-line

  return(
    // <Card>
    //   <CardHeader title={translates.translation[lang].members} className="card-header-primary"/>
    //   {loading?<Preloader/>:
    //   <CardContent className="bg-primary custom-card-body">
    //     {members && members.length?
    //       members.map(m=>(
    //         <MemberCard key={m.id} member={m}/>
    //       )):<div className="pb-1">{translates.translation[lang].sorry_no_members_found}</div>
    //     }
    //   </CardContent>
    //   }
    // </Card>
    <div className="p-1  br-6px">
      {loading?<Preloader/>:
        members && members.length?
        <>
        <div className="d-flex justify-content-center align-item-center">
          {
            members.map(m=>{
              if(m.position === 1){
                return(
                  <div className="ec-wrapper p-05" key={m.id}>
                    <MemberCard  
                    degisnation={m.designation} 
                    image={m.image}
                    name={m.name}
                    id={m.id}
                    sec={true}
                    />
                  </div>
                )
              }
              return "";
            })
          }
        </div>
        <div className="d-flex justify-content-center align-item-center">
        {
          members.map(m=>{
            if(m.position === 2){
              return(
                <div className="ec-wrapper p-05" key={m.id}>
                  <MemberCard  
                  degisnation={m.designation} 
                  image={m.image}
                  name={m.name}
                  id={m.id}
                  sec={true}
                  />
                </div>
              )
            }
            return "";
          })
        }
      </div>
      <div className="d-flex justify-content-center align-item-center">
          {
            members.map(m=>{
              if(m.position === 3){
                return(
                  <div className="ec-wrapper p-05" key={m.id}>
                    <MemberCard  
                    degisnation={m.designation} 
                    image={m.image}
                    name={m.name}
                    id={m.id}
                    sec={true}
                    />
                  </div>
                )
              }
              return "";
            })
          }
        </div>
        <div className="d-flex justify-content-center align-item-center">
          {
            members.map(m=>{
              if(m.position === 4){
                return(
                  <div className="ec-wrapper p-05" key={m.id}>
                    <MemberCard  
                    degisnation={m.designation} 
                    image={m.image}
                    name={m.name}
                    id={m.id}
                    sec={true}
                    />
                  </div>
                )
              }
              return "";
            })
          }
        </div>
      </>
        :<div className="pb-1 text-center">{translates.translation[lang].sorry_no_members_found}</div>
      }   
    </div>
  );
}

export default HomeMembers;